import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { paymentModecolumn } from '../../GSConstants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import TableCellTooltip from "../../../../common/TableCellTooltip"
import { focusElemnt, navigation3, sortTableData } from '../../../../common/helper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

const PaymentModeTable = (props) => {
    const { tableData } = props
    const [showTableData,setShowTableData]=useState([])
    const [searchData, setSearchData] = useState({
        BranchName: "", CityName: "",
    })
    const [orderBy, setOrderBy] = useState('')
    const [order, setOrder] = useState('asc')
    useEffect(() => {
        if (tableData?.length > 0) {
            setShowTableData(tableData)
        } else {
            setShowTableData([])
        }
        setSearchData({BranchName: "", CityName: "",})
    }, [tableData])
    
    useEffect(() => {
        let fiterData = tableData?.filter((val) =>
            (searchData.BranchName === "" || val.BranchName.toString().toLocaleLowerCase().includes(searchData.BranchName.toString().toLocaleLowerCase())) &&
            (searchData.CityName === "" || val.CityName.toLocaleLowerCase().includes(searchData.CityName.toLocaleLowerCase())))
        setShowTableData(fiterData)
    }, [searchData])
    const handleCheckBox = (e, index, field,id) => {
        let newArr = [...showTableData]
        newArr[index][field] = e.target.checked ? 1 : 0
        setShowTableData(newArr)
        setTimeout(()=>{
            focusElemnt(id)
        },100)
        // newArr.map((obj,i)=>i===index?{...obj,[field]:e.target.checked?1:0}:obj)
    }
    const handleSearchData = (event, field) => {
        setSearchData({ ...searchData, [field]: event.target.value })
    }
    const sortData = (e, field, sortOrder, type) => {
        setOrder(sortOrder)
        setOrderBy(field)
        const sortedData = sortTableData(e, field, sortOrder, type, showTableData)
        setShowTableData(sortedData)
      }
    const getBranchId=(index,type,item)=>{
        // onKeyDown={(e) => navigation3(e, index === 2 ?showTableData.length > 0?"BranchCheck-0":"PayModeCompanyName" : `Contains-${index + 1}`, index === 1 ? "PayModeSaveBtn" : `Contains-${index - 1}`, () => { })}
        if(type=="next"){
           if(item?.IsBranchCheck == 1){
            return `CreditDebit-${index}`
           }else if(index+1===showTableData?.length){
            return `PayModeCompanyName`
           } else{
            return `BranchCheck-${index+1}`
        }
        }else{
           if(index==0){
            return "Contains-2"
           }else if(showTableData?.[index-1]?.IsBranchCheck==1) {
            return `Cheque-${index-1}`
           }
           else{
               return `BranchCheck-${index-1}`
           }
        }
    }
    const InsideRowContent = ({ item, index }) => {
        return (
            <TableRow key={`DR-${index}`}>
                <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                    <Checkbox
                        id={`BranchCheck-${index}`}
                        checked={item?.IsBranchCheck == 1}
                        sx={{ padding: "0", borderRadius: "0" }}
                        onChange={(e) => handleCheckBox(e, index, "IsBranchCheck",`BranchCheck-${index}`)}
                        onKeyDown={(e)=>navigation3(e, getBranchId(index,"next",item), getBranchId(index,"prev",item), () => { })}
                    />
                </TableCell>
                <TableCellTooltip title={item.BranchName} data={item.BranchName} placement="bottom-start" textAlign="left" maxWidth="150px" />
                {/* <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}> */}
                <TableCellTooltip title={item.CityName} data={item.CityName} placement="bottom-start" textAlign="left" maxWidth="100px" />
                {/* </TableCell> */}
                <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                    <Checkbox
                        id={`CreditDebit-${index}`}
                        checked={item?.IsCreditDebit == 1}
                        sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                        disabled={item?.IsBranchCheck == 0}
                        onChange={(e) => handleCheckBox(e, index, "IsCreditDebit",`CreditDebit-${index}`)}
                        onKeyDown={(e)=>navigation3(e, `NetBanking-${index}`, `BranchCheck-${index}`, () => { })}
                    />
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                    <Checkbox
                        id={`NetBanking-${index}`}
                        checked={item?.IsNetBanking == 1}
                        sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                        disabled={item?.IsBranchCheck == 0}
                        onChange={(e) => handleCheckBox(e, index, "IsNetBanking",`NetBanking-${index}`)}
                        onKeyDown={(e)=>navigation3(e, `UPI-${index}`, `CreditDebit-${index}`, () => { })}
                    />
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                    <Checkbox
                        id={`UPI-${index}`}
                        checked={item?.IsUPI == 1}
                        sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                        disabled={item?.IsBranchCheck == 0}
                        onChange={(e) => handleCheckBox(e, index, "IsUPI",`UPI-${index}`)}
                        onKeyDown={(e)=>navigation3(e, `Cheque-${index}`, `NetBanking-${index}`, () => { })}
                    />
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                    <Checkbox
                        id={`Cheque-${index}`}
                        checked={item?.IsCheque == 1}
                        sx={{ padding: "0", borderRadius: "0", "&.Mui-disabled": { border: "none !important" } }}
                        disabled={item?.IsBranchCheck == 0}
                        onChange={(e) => handleCheckBox(e, index, "IsCheque",`Cheque-${index}`)}
                        onKeyDown={(e)=>navigation3(e, index+1===showTableData?.length?"PayModeCompanyName":`BranchCheck-${index+1}`, `UPI-${index}`, () => { })}
                    />
                </TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
                    <TableCellTooltip title={item.ModifiedBy} data={item.ModifiedBy} placement="bottom-start" textAlign="left" maxWidth="216px" />
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item.ModifiedDateTime==""?"":moment(item.ModifiedDateTime).format("HH:mm, DD-MMM-YY")} </TableCell>
            </TableRow>
        )
    }


    return (
        <>
            <TableContainer component={Paper} className='scrollBlue' style={{ maxHeight: '65vh', marginBottom: "5px" }} >
                <Table stickyHeader size="small" aria-label="a dense table" sx={{
                    '& .MuiTableCell-root': {
                        padding: '6px !important'
                    }
                }}>
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: "2" }}>
                        <TableRow>
                            {paymentModecolumn.map((val, index) =>
                                <TableCell
                                    key={`TH-${index}`}
                                    style={{
                                        ...val.headerSx,
                                        backgroundColor: '#DAEDFE',
                                        height: '40px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                        textAlign: index == 0 || index == 3 || index == 4 || index == 5||index == 6 ? "center" : ""
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>{val.headerName}</span>
                                        {val.allowSorting && (
                                            <span className="SortingIcons">
                                                <span
                                                    className={`up ${orderBy === val.field && order === 'asc' ? 'active' : ''}`}
                                                    onClick={(e) => sortData(e, val.field, 'asc', val.dataType)}
                                                >
                                                    <FontAwesomeIcon size="lg" icon={faCaretUp} transform="shrink-2" />
                                                </span>
                                                <span
                                                    className={`down ${orderBy === val.field && order === 'desc' ? 'active' : ''}`}
                                                    onClick={(e) => sortData(e, val.field, 'desc', val.dataType)}
                                                >
                                                    <FontAwesomeIcon size="lg" icon={faCaretDown} transform="shrink-2" />
                                                </span>
                                            </span>
                                        )}
                                    </div>
                                </TableCell>
                                // <TableCell key={`TH-${index}`} style={{ ...col.headerSx, textAlign: index == 0 || index == 3 || index == 4 || index == 5||index == 6 ? "center" : "", backgroundColor: '#DAEDFE', height: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>{col.headerName}</TableCell>
                            )}
                        </TableRow>
                        <TableRow>
                            {paymentModecolumn.map((col, index) => col.showfilter ?
                                <TableCell key={`FTH-${index}`}>
                                    <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                        <input
                                            id={`Contains-${index}`}
                                            className="field"
                                            name="cancelSearchInput"
                                            style={{ width: '100%', height: "24px" }}
                                            placeholder="Contains"
                                            onChange={(e) => handleSearchData(e, col.field)}
                                            value={searchData[col.field]}
                                            // onKeyDown={(e) => navigation2(e, `index-${index - 1}`,`index-${index + 1}`)}
                                            onKeyDown={(e) => navigation3(e, index === 2 ?showTableData.length > 0?"BranchCheck-0":"PayModeCompanyName" : `Contains-${index + 1}`, index === 1 ? "PayModeSaveBtn" : `Contains-${index - 1}`, () => { })}
                                        // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? `Edit-${showTableData?.length - 1}` : `index-${index - 1}`, index === 10 ? 'Edit-0' : `index-${index + 1}`)}
                                        />
                                        <FilterAltIcon style={{ color: "#aaa" }} />
                                    </div>
                                </TableCell>
                                : <TableCell></TableCell>)}
                        </TableRow>
                    </TableHead>
                    {showTableData?.length <= 0 ? (
                        <>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={14}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: 'red',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span>No results found. Please refine your search parameters and search again.</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </>
                    ) : showTableData.length > 0 ? (
                        <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                            {showTableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} />
                            ))}
                        </TableBody>
                    ) : (
                        ''
                    )}
                </Table>
            </TableContainer>
        </>
    )
}

export default PaymentModeTable